import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'answerSelector'
})
export class AnswerSelectorPipe implements PipeTransform {

  public forcusClasses: Array<any> = [];
  public selectedClasses: Array<any> = [];
  // public x:Array<any>;

  transform(correctAnswer: boolean, value: any, args?: any): any {
    let array = ['', '', '', '', '', '', '', ''];
    if (correctAnswer) {
      array[value.index] = 'correct-answer-selected-circled'; //green and yellow both
    } else {
      if (value.index !== undefined) {
        array[value.index] = 'button-border'; //green 
      }
      if (value.index2 !== undefined) {
        array[value.index2] = 'button-border-wrong'; //yellow
      }
    }
    return array;
  }

  convert(correctAnswer: boolean, value: any, args?: any) {
    let array = ['', '', '', '', '', '', '', ''];
    if (correctAnswer) {
      array[value.index] = 'correct-answer-selected-underlined'; //green and  yellow both
    } else {
      if (value.index !== undefined) {
        array[value.index] = 'answer-underline'; //green
      }
      if (value.index2 !== undefined) {
        array[value.index2] = 'answer-cross';  //yellow
      }
    }
    return array;
  }

  getCorrecctClorCodeForReport(question) {
    let array = ['', '', '', '', '', '', '', ''];
    if (question.isUnderline) {
      // correct answer is underline 
      if (question.userOptionCircle) {
        //user answer is circle
        this.selectedClasses = this.convert(false, { 'index': parseInt(question.selectedAnswerIndex) });
        this.forcusClasses = this.transform(false, { 'index2': parseInt(question.userAnswerIndex) });
      } else {
        // user answer is underline
        if ((question.answeredObj || false)._id == question.correctAnswer._id) {
          // if it's correct one
          this.selectedClasses = this.convert(true, { 'index': parseInt(question.selectedAnswerIndex), 'index2': parseInt(question.userAnswerIndex) });
        } else {
          this.selectedClasses = this.convert(false, { 'index': parseInt(question.selectedAnswerIndex), 'index2': parseInt(question.userAnswerIndex) });
        }
      }
    } else {
      //correct answer is circle
      if (question.userOptionCircle) {
        //user answer is circle
        if ((question.answeredObj || false)._id  == question.correctAnswer._id) {
          // if it's correct one
          this.forcusClasses = this.transform(true, { 'index': parseInt(question.selectedAnswerIndex), 'index2': parseInt(question.userAnswerIndex) });
        } else {
          this.forcusClasses = this.transform(false, { 'index': parseInt(question.selectedAnswerIndex), 'index2': parseInt(question.userAnswerIndex) });
        }
      } else {
        // user answer is underline
        this.selectedClasses = this.convert(false, { 'index2': parseInt(question.userAnswerIndex) });
        this.forcusClasses = this.transform(false, { 'index': parseInt(question.selectedAnswerIndex) });
      }
    }
    array['selectedClasses'] = this.selectedClasses;
    array['forcusClasses'] = this.forcusClasses;
    return array;
  }

  getCorrecctClorCodeForExam(question) {
    let array = ['', '', '', '', '', '', '', ''];
    if (question.userOptionCircle) { //user answer is circle
      this.forcusClasses = this.transform(false,{ 'index': parseInt(question.selectedAnswerIndex), 'index2': parseInt(question.userAnswerIndex) });
    } else { // user answer is underline
      this.selectedClasses = this.convert(false, { 'index': parseInt(question.selectedAnswerIndex), 'index2': parseInt(question.userAnswerIndex) });
    }
    array['selectedClasses'] = this.selectedClasses;
    array['forcusClasses'] = this.forcusClasses;
    return array;
  }

}



// WEBPACK FOOTER //
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/app/shared/pipe/answer-selector.pipe.ts